import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EChallanRegNo from "./component";
import { setRegNo } from "../my-challans/actions";
import { withRouter } from "react-router";

const mapStateToProps = ({
    myChallans: {
        regNo
    },
    user: { isLoggedIn },
    eChallan: { regNumberListShimmerLines }
}) => ({
    regNo,
    isLoggedIn,
    regNumberListShimmerLines
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setRegNoConnect: setRegNo
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EChallanRegNo));

